var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"blog-section"},[_c('div',{staticClass:"container"},[_c('h3',{staticClass:"section-title"},[_vm._v("The Latest from our Blog")]),_c('b-row',{attrs:{"align-h":"between"}},_vm._l((_vm.articles),function(ref){
var image = ref.image;
var title = ref.title;
var date = ref.date;
var id = ref.id;
return _c('div',{key:id,staticClass:"col-md-4"},[_c('BlogCard',{attrs:{"image":image,"title":title,"date":date,"id":id}})],1)}),0)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }